import { render, staticRenderFns } from "./RotorSails.vue?vue&type=template&id=f16142fc&scoped=true&"
import script from "./RotorSails.vue?vue&type=script&lang=js&"
export * from "./RotorSails.vue?vue&type=script&lang=js&"
import style0 from "./RotorSails.vue?vue&type=style&index=0&id=f16142fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16142fc",
  null
  
)

export default component.exports